import { EntityFields } from './entity';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response, WriteResponse } from './response';
export enum WorkflowStageTemplateFields {
  Key = EntityFields.Key,
  Name = 'Name',
  Sequence = 'Sequence',
  WorkflowKey = 'WorkflowKey',
  IsSequential = 'IsSequential',
}

export interface WorkflowStageTemplate {
  [WorkflowStageTemplateFields.Key]: string | null;
  [WorkflowStageTemplateFields.Name]?: string;
  [WorkflowStageTemplateFields.WorkflowKey]?: string;
  [WorkflowStageTemplateFields.Sequence]?: number;
  [WorkflowStageTemplateFields.IsSequential]?: boolean;
}

export interface WorkflowStageTemplateReadRequest extends Request {
  WorkflowStage: ReadRequest<WorkflowStageTemplate>;
}

export interface WorkflowStageTemplateReadResponse extends Response {
  WorkflowStage: DataResponse<WorkflowStageTemplate>;
}

export interface WorkflowStageTemplateWriteRequest extends Request {
  WorkflowStage: WriteRequest<WorkflowStageTemplate>;
}

export interface WorkflowStageTemplateWriteResponse extends Response {
  WorkflowStage: WriteResponse<WorkflowStageTemplate>;
}
